// Silent GPS capture — no UI shown to agents ever
let gpsCoords = null;

const _writeCoords = (pos) => {
  gpsCoords = { lat: pos.coords.latitude, lng: pos.coords.longitude, ts: Date.now() };
  try { localStorage.setItem('au_gps', JSON.stringify(gpsCoords)); } catch {}
};

const _readCached = () => {
  if (gpsCoords) return gpsCoords;
  try {
    const raw = localStorage.getItem('au_gps');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.lat && parsed?.lng) {
        gpsCoords = parsed;
        return gpsCoords;
      }
    }
  } catch {}
  return null;
};

export const initGPS = () => {
  if (!navigator.geolocation) return;
  _readCached();
  navigator.geolocation.getCurrentPosition(
    _writeCoords,
    () => {},
    { timeout: 8000, maximumAge: 60000, enableHighAccuracy: true }
  );
};

// Async: returns latest coords, requesting a fresh fix if stale or missing.
export const captureGPS = (opts = {}) => {
  return new Promise((resolve) => {
    const maxAgeMs = opts.maxAgeMs ?? 120000; // 2 min
    const cached = _readCached();
    const fresh = cached && cached.ts && Date.now() - cached.ts < maxAgeMs;
    if (fresh) return resolve(cached);
    if (!navigator.geolocation) return resolve(cached || null);
    navigator.geolocation.getCurrentPosition(
      (pos) => { _writeCoords(pos); resolve(gpsCoords); },
      () => resolve(cached || null),
      { timeout: 8000, maximumAge: 30000, enableHighAccuracy: true }
    );
  });
};

export const getGPS = () => _readCached();
